"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Divider = function Divider() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "divider"
  });
};

var _default = Divider;
exports.default = _default;